
export const SET_USER = 'SET_USER'
export const CLEAR_USER = 'CLEAR_USER'

export const SET_COLLEGE = 'SET_COLLEGE'

export const SET_HISTORY_SEARCH = 'SET_HISTORY_SEARCH'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js